import React from 'react'
import { GiCancel } from "react-icons/gi";

function CancelButton(props) {
  return (
    <div className="canceldiv">
        <GiCancel onClick={props.toggle} className="cancel" />
      </div>
  )
}

export default CancelButton
